import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const USERS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('USERS');
export const USERS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(USERS_CRUD_ACTION_CONSTANTS);
